import { useQuery } from "@tanstack/react-query"
import { apiFetch } from "../../../framework/api"
import { useAuthToken } from "../../../hooks/useAuthToken"
import type { ListPromoCodesResponse } from "../types"

export function usePromoCodes() {
  const token = useAuthToken()

  return useQuery({
    queryKey: ["promoCodes"],
    queryFn: async () => {
      const response = await apiFetch<ListPromoCodesResponse>("/admin/promo-codes", {
        token,
        method: "GET",
      })
      return response
    },
  })
}
